export default {
  data () {
    return {
      themeName: ''
    };
  },
  created () {
    if (typeof this.themeName !== 'undefined') {
      this.setTheme(this.themeName);
    } else {
      this.setDefaultTheme();
    }
  },
  methods: {
    initPageTheme (model) {
      this.setTheme(model.ThemeName);
      this.$store.dispatch('appContext/setTransparentHeader', model.HeaderThemeName);
      if (model.HideLoginNugde) {
        this.$store.dispatch('appContext/setHiddenLoginNugde');
      }
    },
    setTheme (theme) {
      this.themeName = theme;
      if (theme === 'black') {
        this.$store.dispatch('appContext/setBlackTheme', true);
      } else if (theme === 'blackest') {
        this.$store.dispatch('appContext/setBlackTheme', true);
        this.$store.dispatch('appContext/setBlackestTheme', true);
        document.getElementsByTagName('body')[0].style.backgroundColor = '#000';
      } else {
        this.setDefaultTheme();
      }
    },
    setDefaultTheme () {
      this.$store.dispatch('appContext/setBlackTheme', false);
      this.$store.dispatch('appContext/setBlackestTheme', false);
      document.getElementsByTagName('body')[0].style.backgroundColor = '';
    }
  }
};
